import React from 'react';
import { SVG } from 'components/Elements';

export const SearchIcon = props => (
    <SVG width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/SVG" strokeColor="text" fill="transparent" {...props}>
        <circle cx="4" cy="4" r="3.5" />
        <line x1="7.99174" y1="8.00826" x2="11.6299" y2="11.6464" />
    </SVG>
)